
import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../View.css";
import "./../Grid.css";
import "./../Form.css";
import "./../App.css";
import AlertItem from "../widgets/AlertItem";
import "./APPDashboard.css";
import APPDashboardSearchForm from "./APPDashboardSearchForm";
import ViewUtils from '../ViewUtils';
import { ViewContainer } from "../View";
//import FormDialog from "../../etqa/FormDialog";
import Prompt from '../widgets/Prompt';
import EnhancedToolbar from '../widgets/Toolbar';
import EnhancedTable from '../widgets/ResponsiveTable';
import APPExportReport from './APPExportReport';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Typography } from "antd";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import withMenuPermission from "../widgets/withMenuPermission";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import CardLayout from "../widgets/Card";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const headCells = [
    { id: "ProgrammeStructure", numeric: false, disablePadding: true, label: "Programme Structure" },
    { id: "IndicatorNo", numeric: false, disablePadding: true, label: "Indicator No" },
    { id: "IndicatorName", numeric: false, disablePadding: true, label: "Indicator Name" },
    { id: "CalculationType", numeric: false, disablePadding: true, label: "Calculation Type" },
    { id: "AnnualTargets", numeric: false, disablePadding: true, label: "Full Year APP Targets" },
    { id: "FullYearAchievement", numeric: false, disablePadding: true, label: "Full Year APP Achievement" },
    { id: "FullYearAPPVariance", numeric: false, disablePadding: true, label: "Full Year APP Variance" },
    { id: "PercentageAnnualPerformance", numeric: false, disablePadding: true, label: "Percentage Annual Performance" },
    { id: "Q1Target", numeric: false, disablePadding: true, label: "Q1 Target" },
    { id: "Q1Achievement", numeric: false, disablePadding: true, label: "Q1 Achievement" },
    { id: "Q1Variance", numeric: false, disablePadding: true, label: "Q1 Variance" },
    { id: "Q1Percentage", numeric: false, disablePadding: true, label: "Percentage achieved against Q1 Target" },
    { id: "MigrationPlan", numeric: false, disablePadding: true, label: "Migration Plan" },
    { id: "Q2Target", numeric: false, disablePadding: true, label: "Q2 Target" },
    { id: "Q2Achievement", numeric: false, disablePadding: true, label: "Q2 Achievement" },
    { id: "Q2Variance", numeric: false, disablePadding: true, label: "Q2 Variance" },
    { id: "Q2Percentage", numeric: false, disablePadding: true, label: "Percentage achieved against Q2 Target" },
    { id: "DeviationComment", numeric: false, disablePadding: true, label: "Deviation Comment" },
    { id: "Q3Target", numeric: false, disablePadding: true, label: "Q3 Target" },
    { id: "Q3Achievement", numeric: false, disablePadding: true, label: "Q3 Achievement" },
    { id: "Q3Variance", numeric: false, disablePadding: true, label: "Q3 Variance" },
    { id: "Q3Percentage", numeric: false, disablePadding: true, label: "Percentage achieved against Q3 Target" },
    { id: "Q4Target", numeric: false, disablePadding: true, label: "Q4 Target" },
    { id: "Q4Achievement", numeric: false, disablePadding: true, label: "Q4 Achievement" },
    { id: "Q4Variance", numeric: false, disablePadding: true, label: "Q4 Variance" },
    { id: "Q4Percentage", numeric: false, disablePadding: true, label: "Percentage achieved against Q4 Target" },
    { id: "IndicatorResponsibility", numeric: false, disablePadding: true, label: "Indicator Responsibility" },
];



const utils = new ViewUtils();
const addFormRef = React.createRef();
const toolbarRef = React.createRef();

const useStyles = theme => ({
    appBar: {
        position: 'relative',
    },
    title: {
        flex: 1,
        color: 'white',
    },
    table: {
        minWidth: 700,
    },
});

class APPDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataObject: null,
            keyUpSwitch: false,
            addDialogOpen: false,
            editDialogOpen: false,
            selectedDGApplication: null,
            lookupFinArray: null,
            FinancialYearID: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.FinancialYearID)) ? this.props.location.state.FinancialYearID : null,
            promptOpen: false,
            searchParameters: [{ Name: "FinancialYearID", Value: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.FinancialYearID)) ? this.props.location.state.FinancialYearID : null }],
            dependency: null,
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: "report", label: "Report into Excel", tooltip: "Export to Excel" ,icon: "AssessmentIcon", disabled: true },

                    ]
                }
            ]
        }
    }

    componentDidMount() {
        this.getlookup()
    }

    handleToolbarButtonClick(buttonId) {
        if ("report" === buttonId) {
            this.setState({ OpenPrintDialog: true });
        }
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }


    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            if (!utils.isNull(selection)) {
                this.setState({ selectedDGApplication: selection[0].Id }, () => {
                });
            }
        } else {
            this.setState({ selectedDGApplication: null });
        }
    }

    handleFormValueChange(values) {

        let FinancialYearID = values.FinancialYearID.Id;
        let newsearchParameters = [...this.state.searchParameters];
        let temp_element = { ...newsearchParameters[0] };
        temp_element.Value = FinancialYearID
        newsearchParameters[0] = temp_element;

        this.setState({
            searchParameters: JSON.parse(JSON.stringify(newsearchParameters)),
            FinancialYearID: FinancialYearID
        });
    }

    ClosePrintDialog = () => {
        this.setState({ OpenPrintDialog: false });
        toolbarRef.current.setButtonDisabled("report", utils.isNull(this.state.FinancialYearID));
    };

    getlookup() {
        let url = "api/sims/APPDashboard/GetLookupList?listId=APPFinancialYear";
        utils.invokeUrl(url, (response) => {
            this.setState({ lookupFinArray: response })
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    
    handleFinancialYear = (event) => {
        let FinancialYearID = event.target.value;
        let newsearchParameters = [...this.state.searchParameters];
        let temp_element = { ...newsearchParameters[0] };
        temp_element.Value = FinancialYearID
        newsearchParameters[0] = temp_element;

        this.setState({
            searchParameters: JSON.parse(JSON.stringify(newsearchParameters)),
            FinancialYearID: FinancialYearID
        }, () => {
            if (this.state.FinancialYearID !== 0) {
                this.getData();

            }
        });

    }

    getData = () => {
        let url = "api/sims/appdashboard/GetAppDashboard?FinancialYearId=" + this.state.FinancialYearID;
        utils.invokeUrl(url, (response) => {
            this.setState({
                dataObject: response
            })
            
        if (!utils.isNull(response) && !utils.isNull(response.APPDashboardDto) && response.APPDashboardDto.length > 0)
        {
            toolbarRef.current.setButtonDisabled("report", false);
        }
        else
            {
                toolbarRef.current.setButtonDisabled("report", true);
        }
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    render() {
        const { classes } = this.props;
        return (
             <CardLayout title="">
            <div>
                <p className="breadcrumbs">
                    {"APP Dashboard"}
                </p>
                <br />
                <AlertItem message={this.state.Message} alertStyle={this.state.MessageStyle} />


                    <EnhancedToolbar highlight={false}
                        title=""
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig}
                    />

                                            <div className="row" style={{ width: "90%" }}>
                                            <div className="col w-100">
                                                <table cellPadding="2" width="80%">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <TextField className="w-100" id="FinancialYearID" select margin="normal" size="small" variant="outlined" value={this.state.FinancialYearID} label="Financial Year" style={{ minWidth: "200px", width: "100% !important" }} onChange={(values) => this.handleFinancialYear(values)} >
                                                                    <MenuItem value={0} key={0} >  </MenuItem>
                                                                    {!utils.isNull(this.state.lookupFinArray) ? this.state.lookupFinArray.map((lookupFinArray, index) => (
                    
                                                                        <MenuItem value={lookupFinArray.Id} key={lookupFinArray.Id} >{lookupFinArray.Description}</MenuItem>
                    
                                                                    )) : null}
                                                                </TextField>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                    
                                            </div>
                                        </div>
                                        
                                                            <br />
{(!utils.isNull(this.state.dataObject) && !utils.isNull(this.state.dataObject.APPDashboardDto)) ? (
  <div className="outer-wrapper">
    <div className="table-container">
      <table className="custom-table">
        <thead>
          <tr>
            <th style={{ width: '200px' }}>Programme Structure</th>
            <th style={{ width: '100px' }}>Indicator No</th>
            <th style={{ width: '250px' }}>Indicator Name</th>
            <th style={{ width: '150px' }}>Calculation Type</th>
            <th style={{ width: '150px' }}>Full Year APP Targets</th>
            <th style={{ width: '150px' }}>Full Year APP Achievement</th>
            <th style={{ width: '150px' }}>Full Year APP Variance</th>
            <th style={{ width: '150px' }}>Percentage Annual Performance</th>
            <th style={{ width: '80px' }}>Q1 Target</th>
            <th style={{ width: '120px' }}>Q1 Achievement</th>
            <th style={{ width: '100px' }}>Q1 Variance</th>
            <th style={{ width: '150px' }}>Percentage achieved against Q1 Target</th>
            <th style={{ width: '200px' }}>Migration Plan</th>
            <th style={{ width: '80px' }}>Q2 Target</th>
            <th style={{ width: '120px' }}>Q2 Achievement</th>
            <th style={{ width: '100px' }}>Q2 Variance</th>
            <th style={{ width: '150px' }}>Percentage achieved against Q2 Target</th>
            <th style={{ width: '200px' }}>Deviation Comment</th>
            <th style={{ width: '80px' }}>Q3 Target</th>
            <th style={{ width: '120px' }}>Q3 Achievement</th>
            <th style={{ width: '100px' }}>Q3 Variance</th>
            <th style={{ width: '150px' }}>Percentage achieved against Q3 Target</th>
            <th style={{ width: '80px' }}>Q4 Target</th>
            <th style={{ width: '120px' }}>Q4 Achievement</th>
            <th style={{ width: '100px' }}>Q4 Variance</th>
            <th style={{ width: '150px' }}>Percentage achieved against Q4 Target</th>
            <th style={{ width: '200px' }}>Annual Deviation</th>
            <th style={{ width: '200px' }}>Indicator Responsibility</th>
          </tr>
        </thead>
        <tbody>
          {this.state.dataObject.APPDashboardDto.length > 0 ? (
            this.state.dataObject.APPDashboardDto.map((item) => (
              <tr key={item.id}>
                <td>{item.ProgrammeStructure}</td>
                <td className="text-numeric-bold">{item.IndicatorNo}</td>
                <td className="text-wrap">{item.IndicatorName}</td>
                <td>{item.CalculationType}</td>
                <td className="text-numeric-bold">{item.AnnualTargets}</td>
                <td className="text-numeric-bold">{item.FullYearAchievement}</td>
                <td className="text-numeric-bold">{item.FullYearAPPVariance}</td>
                <td className="text-numeric-bold">{item.PercentageAnnualPerformance}%</td>
                <td className="text-numeric-bold">{item.Q1Target}</td>
                <td className="text-numeric-bold">{item.Q1Achievement}</td>
                <td className="text-numeric-bold">{item.Q1Variance}</td>
                <td className="text-numeric-bold">{item.Q1Percentage}%</td>
                <td className="text-truncate" title={item.MigrationPlan}>{item.MigrationPlan}</td>
                <td className="text-numeric-bold">{item.Q2Target}</td>
                <td className="text-numeric-bold">{item.Q2Achievement}</td>
                <td className="text-numeric-bold">{item.Q2Variance}</td>
                <td className="text-numeric-bold">{item.Q2Percentage}%</td>
                <td className="text-truncate" title={item.DeviationComment}>{item.DeviationComment}</td>
                <td className="text-numeric-bold">{item.Q3Target}</td>
                <td className="text-numeric-bold">{item.Q3Achievement}</td>
                <td className="text-numeric-bold">{item.Q3Variance}</td>
                <td className="text-numeric-bold">{item.Q3Percentage}%</td>
                <td className="text-numeric-bold">{item.Q4Target}</td>
                <td className="text-numeric-bold">{item.Q4Achievement}</td>
                <td className="text-numeric-bold">{item.Q4Variance}</td>
                <td className="text-numeric-bold">{item.Q4Percentage}%</td>
                <td className="text-truncate" title={item.AnnualDeviation}>{item.AnnualDeviation}</td>
                <td className="text-truncate" title={item.IndicatorResponsibility}>{item.IndicatorResponsibility}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="27" style={{ textAlign: 'center', padding: '30px', backgroundColor: '#fdfdfd' }}>
                <div style={{ color: '#888', fontSize: '16px' }}>
                  <strong>No Data Available</strong>
                  <p style={{ margin: '5px 0 0' }}>There are currently no indicators to display for this financial year.</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
) : null}

            </div>
                <Dialog fullScreen open={this.state.OpenPrintDialog} TransitionComponent={Transition}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={this.ClosePrintDialog} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h1" className={classes.title}>
                                Export APP Report
                            </Typography>
                        </Toolbar >
                    </AppBar >
                    <APPExportReport FinancialYearID={this.state.FinancialYearID} classes={classes} />
                </Dialog>

            </CardLayout>
        );
    }
}

export default withRouter(withStyles(useStyles())(withMenuPermission(APPDashboard)));
